import { Ref } from "@tblabs/truffle";



export class CustomerAddress
{
    public Street = new Ref<string>("").Storable("customer-address-street");
    public PostalCode = new Ref<string>("").Storable("customer-address-postal-code");
    public City = new Ref<string>("").Storable("customer-address-city");

    public get AsString(): string
    {
        return this.PostalCode.value + " " + this.City.value + ", " + this.Street.value;
    }
}
